<div class="settings-page">
  <div [hidden]="editUserMode">
    <div class="container-fluid clearfix">
      <span class="subheader">ADMINISTRATION</span>
      <h1>System Settings</h1>

      <mat-card class="card-style">
        <div class="row center-container">
          <div>
            <h3>SIA Audio Lifecycle</h3>
            &emsp;This setting will change how far back in time a user can pick a day/date in the date picker calendar <br />
            &emsp;in the DOWNLOADS and LINEAR PLAYOUT sections. <br />
            &emsp;The actual retention policy still needs to be changed in the AWS “sia-prod” S3 bucket.
          </div>
          <mat-form-field appearance="standard">
            <input
              matInput
              placeholder="number of days"
              [(ngModel)]="config.value"
              type="number"
              min="1"
              max="365"
            /> 
          </mat-form-field>
          days
        </div>
      </mat-card>

      <div>
        <button 
          mat-button
          class="float-right primary-button no-outline"
          (click)="updateLifecycle()">
            {{ updateButtonText }}
        </button>
        <button 
          mat-button 
          class="float-right no-outline">
            {{ cancelButtonText }}
        </button>
      </div>
    </div>

    <div class="container-fluid clearfix container-space">
      <span class="subheader">ANNOUNCEMENTS</span>
      <h1>Configure Message</h1>

      <mat-card class="card-style">
        <div class="row center-container">
          <div class="col-lg-12 mb-4">
            <mat-form-field appearance="standard" class="d-inline">
              <mat-label>Announcement</mat-label>
              <textarea matInput></textarea>
            </mat-form-field>
            <app-date-picker
              class="w-100"
              [startFormControl]="announcementsForm.controls.startTime"
              [endFormControl]="announcementsForm.controls.endTime"
              #datePicker
            >
            </app-date-picker>
          </div>
        </div>
      </mat-card>

      <div>
        <button mat-button class="float-right primary-button no-outline">
          {{ updateButtonText }}
        </button>
        <button mat-button class="float-right no-outline">
          {{ cancelButtonText }}
        </button>
        <button mat-button class="float-right no-outline">CLEAR</button>
      </div>
    </div>

    <div class="container-fluid clearfix container-space">
      <span class="subheader">ROLES & PERMISSIONS</span>
      <h1>Manage Users</h1>

      <mat-accordion class="roles-and-permissions">
        <mat-expansion-panel
          class="panel-margin-16"
          [expanded]="openedPanel === 'STANDARD'"
          (opened)="openStandardUsersPanel()"
          (closed)="stdPanelText = 'Standard Users'"
          hideToggle
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h3 *ngIf="stdPanelText" class="title">{{ stdPanelText }}</h3>
            </mat-panel-title>
            <mat-panel-description>
              <span
                *ngIf="stdPanelText"
                matTooltip="Manage Users"
                matTooltipPosition="above"
              >
                <span class="total-users"
                  >{{ standardUsersDataSource.totalRecords() }} Users</span
                >
                <mat-icon class="s-group-icon">group</mat-icon>
              </span>
              <span *ngIf="stdPanelText === undefined" class="span-icon">
                <mat-icon
                  class="p-close"
                  matTooltip="Close"
                  matTooltipPosition="above"
                  >clear</mat-icon
                >
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-grid-list cols="10" rowHeight="70px" class="m-grid-list">
            <mat-grid-tile [colspan]="7">
              <h2>Current Standard Users</h2>
            </mat-grid-tile>

            <mat-grid-tile class="text-align-left" [colspan]="3">
              <mat-form-field floatLabel="never" class="search-form-field">
                <input
                  matInput
                  placeholder="Search (Text from any Column)"
                  #standardUsersSearchInput
                />
                <mat-icon matSuffix class="search-icon">search</mat-icon>
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>

          <mdt-dynamic-table
            #standardUsersTable
            [columns]="standardUsersColumns"
            [dataSource]="standardUsersDataSource"
          ></mdt-dynamic-table>
        </mat-expansion-panel>

        <mat-expansion-panel
          class="adm-panel"
          [expanded]="openedPanel === 'ADMIN'"
          (opened)="openAdminUsersPanel()"
          (closed)="admPanelText = 'Administrators'"
          hideToggle
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h3 *ngIf="admPanelText" class="title">{{ admPanelText }}</h3>
            </mat-panel-title>
            <mat-panel-description>
              <span
                *ngIf="admPanelText"
                matTooltip="Manage Users"
                matTooltipPosition="above"
              >
                <span class="total-users"
                  >{{ adminUsersDataSource.totalRecords() }} Users</span
                >
                <mat-icon class="s-group-icon">group</mat-icon>
              </span>
              <span *ngIf="admPanelText === undefined" class="span-icon">
                <mat-icon
                  class="p-close"
                  matTooltip="Close"
                  matTooltipPosition="above"
                  >clear</mat-icon
                >
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-grid-list cols="10" rowHeight="70px" class="m-grid-list">
            <mat-grid-tile class="text-align-left" [colspan]="7">
              <h2>Administrators</h2>
            </mat-grid-tile>
            <mat-grid-tile class="text-align-left" [colspan]="3">
              <mat-form-field floatLabel="never" class="search-form-field">
                <input
                  matInput
                  placeholder="Search (Text from any Column)"
                  #adminUsersSearchInput
                />
                <mat-icon matSuffix class="search-icon">search</mat-icon>
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
          <mdt-dynamic-table
            #adminUsersTable
            [columns]="standardUsersColumns"
            [dataSource]="adminUsersDataSource"
          ></mdt-dynamic-table>
          <!--
                        <app-data-table class="w-100" #adminUsersGrid [dataSource]="adminUsersDataSource"
                            (refresher)="refreshGrid($event)" [displayedColumns]="displayedColumns" matSort
                            matSortActive="name" matSortDirection="asc" matSortDisableClear
                            noResultMessage="No matches based on your search">
                            <app-data-column name="name"></app-data-column>
                            <app-data-column name="email" label="Email"></app-data-column>
                            <app-data-column name="edit" [ignoreIfValue]="currentUserEmail" label="&nbsp;" [editable]="true"
                                (editIconClicked)="editUser($event)" [disabledSort]="true"></app-data-column>
                        </app-data-table>
                    -->
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="container-fluid clearfix container-space">
      <!-- TODO: remove after prod push -->
      <span class="subheader">Logs</span>
      <h1>Silence Detection</h1>

      <mat-card>
        <ag-grid-angular
          class="ag-theme-material ag-grid-wrapper ag-silence-logs"
          #silenceLogsGrid
          [headerHeight]="35"
          [rowHeight]="40"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          rowSelection="single"
          (gridReady)="onGridReady($event)"
          [animateRows]="true"
          [enableRangeSelection]="true"
          [allowContextMenuWithControlKey]="true"
          [paginationAutoPageSize]="true"
          [pagination]="true"
          rowModelType="infinite"
          cacheBlockSize="10"
          paginationPageSize="10"
        >
        </ag-grid-angular>
      </mat-card>
    </div>
  </div>
  <div [hidden]="!editUserMode">
    <div class="container-fluid clearfix">
      <span class="subheader">ROLES & PERMISSIONS</span>
      <h1>Manage User</h1>
      <mat-card class="role-card-style">
        <div class="row center-container">
          <div class="col-lg-12 mb-4">
            <h3>User Details</h3>
          </div>
          <div class="col-lg-12 mb-4">
            <mat-form-field disabled appearance="standard">
              <input
                disabled
                matInput
                placeholder="Name"
                [(ngModel)]="userToEdit.name"
              />
            </mat-form-field>
          </div>
          <div class="col-lg-12 mb-4">
            <mat-form-field disabled appearance="standard">
              <input
                disabled
                matInput
                placeholder="Email"
                [(ngModel)]="userToEdit.email"
              />
            </mat-form-field>
          </div>
          <div class="col-lg-12 mb-4">
            <h3 class="store-data-p">Role</h3>
            <mat-form-field>
              <mat-select [(ngModel)]="userToEdit.role">
                <mat-option value="ADMIN">Admin User</mat-option>
                <mat-option value="STANDARD">Standard User</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-card>

      <div>
        <button
          mat-button
          class="float-right primary-button no-outline"
          (click)="updateUser()"
        >
          {{ updateButtonText }}
        </button>
        <button
          mat-button
          class="float-right no-outline"
          (click)="returnToSettingsView()"
        >
          {{ cancelButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
